// import components
import { styled, Box, BoxProps } from '@mui/material';

export const StyledPatientSearchBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',

  '.MuiAutocomplete-root': {
    minWidth: theme.spacing(75),

    '.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon': {
      padding: 0
    },

    '.MuiInput-root.MuiInput-underline.input-box': {
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing(0.5, 1.5, 0.5),

      input: {
        marginRight: theme.spacing(1)
      }
    },

    '.MuiChip-root': {
      margin: theme.spacing(0, 1, 0),
      backgroundColor: 'unset',
      height: 'auto',
      border: 0,

      '.MuiChip-label': {
        paddingLeft: 0
      }
    },

    '.MuiAutocomplete-tag': {
      height: 'auto'
    }
  }
}));
